import React from 'react';
import Tabs from '../Tabs.jsx';
import { ArchivedProjectsLink, ProjectsLink } from '../links/index.jsx';

const ProjectsTabs = () => (
  <Tabs>
    <Tabs.Tab label="Active">
      <ProjectsLink />
    </Tabs.Tab>
    <Tabs.Tab label="Archived">
      <ArchivedProjectsLink />
    </Tabs.Tab>
  </Tabs>
);

export default ProjectsTabs;
